import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"

import Loading from "@irati/ui/src/Loading"
import Button from "@irati/ui/src/Button"
import SignUpOption from "./SignUpOption"
import {NONE} from "../../../../constants/selfSignUp"

class DoNotAllow extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    submit: PropTypes.object.isRequired,
    selfSignUp: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired
  }

  doNotAllowSelfSignUp = () => {
    this.props.onChange("method", NONE)
    this.props.onSubmit()
  }

  render() {
    const {formatMessage} = this.props
    return (
      <SignUpOption
        title={formatMessage({id: "admin.components.doNotAllow.signUpOption.title"})}
        description={formatMessage({id: "admin.components.doNotAllow.signUpOption.description"})}
        onClick={() => this.props.onSelect(NONE)}
        active={this.props.show}>
        {get(this.props.selfSignUp, "method", NONE) !== NONE &&
          <React.Fragment>
            <Loading load={this.props.submit} useLoader={false} />
            <Button
              primary
              full
              large
              load={this.props.submit}
              onClick={this.doNotAllowSelfSignUp}>
              <FormattedMessage id="admin.components.doNotAllow.button.save" />
            </Button>
          </React.Fragment>
        }
      </SignUpOption>
    )
  }
}

export default injectIntl(DoNotAllow)
